var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconPolicy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 18.5907C14.4636 17.6856 15.9416 16.4436 16.7843 14.7568C17.6119 13.1003 17.9291 10.8156 17.6417 7.57666C15.4092 7.34877 13.8849 6.87707 11.9821 5.87799C10.1117 6.81171 8.60495 7.26773 6.36105 7.54505C6.06892 10.7987 6.38492 13.0923 7.21413 14.754C8.05664 16.4423 9.535 17.6851 12 18.5907ZM11.6826 20.0707C6.02887 18.0708 4.08495 14.1745 4.95167 6.58329C4.97837 6.34943 5.16833 6.16508 5.40258 6.14195C8.13763 5.87182 9.6189 5.42765 11.7573 4.30808C11.9087 4.22885 12.0901 4.23079 12.2397 4.31321C14.4095 5.50855 15.8927 5.95929 18.5843 6.15243C18.8245 6.16967 19.0224 6.35604 19.0496 6.59534C19.9129 14.1786 17.968 18.0719 12.3173 20.0707C12.1134 20.1429 11.8866 20.1429 11.6826 20.0707Z",
    fill: "#3D3D3D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0303 9.39936C16.3232 9.69225 16.3232 10.1671 16.0303 10.46L11.7873 14.7029C11.4906 14.9997 11.0093 14.9998 10.7125 14.7029L8.46961 12.46C8.17672 12.1671 8.17672 11.6923 8.46961 11.3994C8.7625 11.1065 9.23738 11.1065 9.53027 11.3994L11.2499 13.119L14.9696 9.39936C15.2625 9.10647 15.7374 9.10647 16.0303 9.39936Z",
    fill: "#AD49CF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPolicy);
export default __webpack_public_path__ + "static/media/icon-policy.5da92d4b64e0d872b85117ccd6fec40f.svg";
export { ForwardRef as ReactComponent };